import React, { ReactNode, PropsWithChildren } from 'react';
import { SidebarMenu, SidebarMenuSection } from '@ardoq/sidebar-menu';
import styled from 'styled-components';
import { s16 } from '@ardoq/design-tokens';
import { text1 } from '@ardoq/typography';

export type TabDescription = {
  title?: string;
  description?: string;
  knowledgeBaseLink?: string;
};

type Section = TabDescription & {
  /** a unique identifier, for React */
  key: string;
  content: ReactNode;
};

type LayoutProps = {
  sections: Section[];
};

const TabLayoutWrapper = styled.div`
  overflow: auto;
  flex: 1;
  width: 100%;
`;
const ScrollableContent = styled.div`
  width: fit-content;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;
const SidebarMenuLayoutInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${s16};
  height: 100%;
  padding: ${s16} ${s16} 0 ${s16};
`;
const DescriptionContainer = styled.div`
  ${text1};
`;

type TabSectionWrapperProps = {
  title?: string;
  knowledgeBaseLink?: string;
};

const TabSectionWrapper = ({
  title,
  knowledgeBaseLink,
  children,
}: PropsWithChildren<TabSectionWrapperProps>) => {
  if (title) {
    return (
      <SidebarMenuSection
        title={title}
        knowledgeBaseLink={knowledgeBaseLink}
        isCollapsible={false}
      >
        {children}
      </SidebarMenuSection>
    );
  }
  return <>{children}</>;
};

export const TabLayout = ({ sections }: LayoutProps) => (
  <TabLayoutWrapper>
    <ScrollableContent>
      <SidebarMenu>
        {sections.map(section => (
          <TabSectionWrapper
            title={section.title}
            knowledgeBaseLink={section.knowledgeBaseLink}
            key={section.key}
          >
            <SidebarMenuLayoutInner>
              {section.description && (
                <DescriptionContainer>
                  {section.description}
                </DescriptionContainer>
              )}
              {section.content}
            </SidebarMenuLayoutInner>
          </TabSectionWrapper>
        ))}
      </SidebarMenu>
    </ScrollableContent>
  </TabLayoutWrapper>
);
